if (!customElements.get('component-complete-the-look')) {
  customElements.define('component-complete-the-look', class CompleteTheLook extends HTMLElement {
    constructor() {
      super();
      this.props = {
        shopUrl: this.dataset.shopUrl,
        productsSource: this.dataset.productsSource,
        productId: this.dataset.productId,
        productShowLimit: this.dataset.productShowLimit,
        intent: this.dataset.intent,
        designMode: this.dataset.designMode === 'true'
      }
    }
    connectedCallback() {
      if (!this.props.designMode && this.props.productsSource == 'api') {
        this.fetchRecommendations(this.props.productId);
        document.addEventListener('update-pdp-sections', (event) => {
          this.fetchRecommendations(event.detail.productId);
        });
      }
    }
    fetchRecommendations(productId) {
      const productRecommendationsSection = this.querySelector('.js-template');
      fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=${this.props.productShowLimit}&section_id=complete-the-look-products&intent=${this.props.intent}`)
      .then(response => response.text())
      .then((text) => {
          if (text) {
            productRecommendationsSection.innerHTML = text;
            this.classList.remove('hidden');
            setTimeout(() => this.equalizeAllColorHeights(), 500);
          } else {
            this.classList.add('hidden');
          }
      }).catch((error) => {
        console.error(error);
        this.classList.add('hidden');
      });
    }
    equalizeAllColorHeights() {
      if (window.innerWidth < 1025) return;
      
      const allColorContainers = this.querySelectorAll('.js-colors');
      if (allColorContainers.length === 0) return;

      allColorContainers.forEach(container => {
        container.style.minHeight = '';
      });

      let maxHeight = 0;
      allColorContainers.forEach(container => {
        const height = container.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      if (maxHeight > 0) {
        allColorContainers.forEach(container => {
          container.style.minHeight = `${maxHeight}px`;
        });
      }
    }
    async processProduct(product) {
      if (product.status === 'active' && product.product_type !== 'Kit' && product.images?.length > 0 && product.handle) {
        const html = await this.getProductHTML(product.handle);
        const div = document.createElement('div');
        div.innerHTML = html;
        return div;
      }
      return null;
    }
    async getProductHTML(handle) {
      // Get product data
      let response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=complete-the-look-product`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.text();
      return response;
    }
  })
}

if (!customElements.get('component-complete-the-look-product')) {
  customElements.define('component-complete-the-look-product', class CompleteTheLookProduct extends HTMLElement {
    constructor() {
      super();
      this.componentId = `complete-look-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      
      this.state = {
        bandSize: null,
        cupSize: null,
        formFitSize: '',
        product: '',
        response: '',
        trueSize: '',
        selectedVariantId: null,
        selectedVariant: null,
        selectedColor: null
      }
      this.props = {
        url: this.dataset.url,
        productHandle: this.dataset.productHandle,
        id: this.dataset.productId || this.componentId,
        productType: this.dataset.productType,
      }
      this.dom = {
        parentComponent: this.closest('component-complete-the-look'),
      }
      this.props.useTrueSize = this.dom.parentComponent?.dataset.useTrueSize === 'true';
    }
    connectedCallback() {
      this.renderCompleteTheLook();
    }
    async renderCompleteTheLook() {
      const response = await fetch(`${this.props.url}${this.props.url.includes('?') ? '&' : '?'}view=complete-the-look-json&currency=${window.Shopify.currency.active}&country=${window.Shopify.country}`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      this.state.response = await response.json();
      this.state.product = await this.getProduct();

      this.renderColors();
      if (this.hasBandCup()) {
        this.renderSizes("band", 0, 2);
        this.renderSizes("cup", 2, undefined);
      } else {
        this.renderSizes("alpha", 0, undefined);
      }
      this.handleSizeSelection();
      this.handleAddToBag();

      this.handleColorSwatchChange();

      this.selectFirstColor();

      setTimeout(() => this.equalizeColorHeights(), 100);
      setTimeout(() => this.equalizeColorHeights(), 400); 

      window.addEventListener('resize', () => this.equalizeColorHeights());
    }

    selectFirstColor() {
      const options = this.querySelectorAll('.js-colors .js-color');
      if (options.length > 0) {
        const input = options[0].querySelector('.js-input');
        input.checked = true;
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);
      }
    }

    equalizeColorHeights() {
      
      const parentContainer = this.dom.parentComponent;
      if (!parentContainer) return;

      const allColorContainers = parentContainer.querySelectorAll('.js-colors');
      if (allColorContainers.length === 0) return;

      allColorContainers.forEach(container => {
        container.style.minHeight = '';
      });

      let maxHeight = 0;
      allColorContainers.forEach(container => {
        const height = container.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      if (maxHeight > 0) {
        allColorContainers.forEach(container => {
          container.style.minHeight = `${maxHeight}px`;
        });
      }
    }

    async getProduct() {
      let response = await fetch(`${window.Shopify.routes.root}products/${this.props.productHandle}?view=collection-grid-json`, {
        method: "get"
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      response = await response.json();
      return response;
    }

    async setTrueSize() {
      const isUnderwear = this.state.response.type === 'Panties';
      const trueSize = await getTrueSize();
      if (trueSize) {
        this.state.trueSize = isUnderwear ? trueSize.underwear_size : `${trueSize.bra_band}${trueSize.bra_cup}`;
      }
    }
    async renderColors() {
      if (this.state.product?.colors && Object.keys(this.state.product.colors).length > 0) {
        for (const color in this.state.product.colors) {
          let showColorSwatch = false;
          let hasAvailableSize;
          let availableSize;
          if (this.props.sizeType === 'formFit' && this.props.formFitSize) {
            hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.formFitSize));
            availableSize = this.props.formFitSize;
          } else if (this.props.sizeType === 'alpha' && this.props.alphaSize) {
            hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.alphaSize));
            availableSize = this.props.alphaSize;
          } else if (this.props.sizeType === 'bra' && this.props.braSize) {
            const range = this.getRange(this.props.braSize);
            hasAvailableSize = this.state.product.colors[color].availableSizes.some(el => el.includes(this.props.braSize) || el.includes(range));
            availableSize = this.props.braSize;
          } else {
            showColorSwatch = true;
          }
          if (hasAvailableSize) {
            this.state.availableSize = availableSize;
            showColorSwatch = true;
          }
          if (showColorSwatch) {
            // Prepare color swatch to be added
            const colorTemplate = this.querySelector('.js-template-color').content.cloneNode(true);
            if (window.theme.colors[color]) {
              // Set CSS custom properties for swatch styling
              if (window.theme.colors[color].image) {
                colorTemplate.querySelector('.js-label').style.setProperty('--swatch-image', `url(${window.theme.colors[color].image}`);
              }
              colorTemplate.querySelector('.js-label').style.setProperty('--swatch-color', window.theme.colors[color].color);
              colorTemplate.querySelector('.js-label').style.setProperty('--swatch-border-color', '#fff');
            }
            if (color === this.props.color) {
              colorTemplate.querySelector('.js-input').checked = true;
              colorTemplate.querySelector('.js-color').classList.add("first");
            }
            colorTemplate.querySelector('.js-label').setAttribute('for', `color_${color}_${this.props.id}`);
            colorTemplate.querySelector('.js-label').dataset.color = color;
            colorTemplate.querySelector('.js-input').value = color;
            colorTemplate.querySelector('.js-input').id = `color_${color}_${this.props.id}`;
            this.querySelector('.js-colors').appendChild(colorTemplate);
          }
          this.querySelector('.js-colors').classList.add('opacity-1');
        }
      } else {
        // Remove color class in color swatches wrapper if no colors available (for example, for a bundle product)
        this.querySelector('.js-colors').classList.remove('colors');
      }
    }

    handleColorSwatchChange() {
      const self = this;
      this.querySelectorAll('.js-colors .js-input').forEach(color => {
        color.addEventListener('change', () => {
          self.querySelectorAll('.js-colors .js-color').forEach(option => {
            option.classList.remove('selected');
          });
          color.closest('.js-color').classList.add('selected');

          self.querySelectorAll('.js-link').forEach(link => {
            if (self.state.availableSize) {
              link.href = `${self.state.product.colors[color.value].url}${self.state.product.colors[color.value].url.includes('?') ? '&' : '?'}size=${self.state.availableSize}`;
            } else {
              link.href = self.state.product.colors[color.value].url;
            }
          });
          let img;
          img = self.state.product.colors[color.value].images[0].src;
          self.renderImages(img);
          this.state.response.availableSizes = self.state.product.colors[color.value].availableSizes;

          // Set selected color
          self.state.selectedColor = color.value;

          if (!self.hasBandCup()) {
            // Enable alpha dropdown when color is selected
            const alphaDropdown = self.querySelector('.js-sizes .js-size-alpha .js-size-dropdown');
            if (alphaDropdown) {
              alphaDropdown.disabled = false;
            }
            self.updateSizeDropdown('alpha');
          } else {
            // Reset band and cup values when color changes
            self.state.bandSize = null;
            self.state.cupSize = null;
            self.state.selectedVariantId = null;
            self.state.selectedVariant = null;
            
            // Reset dropdown selections
            const bandDropdown = self.querySelector('.js-sizes .js-size-band .js-size-dropdown');
            const cupDropdown = self.querySelector('.js-sizes .js-size-cup .js-size-dropdown');
            
            if (bandDropdown) {
              bandDropdown.selectedIndex = 0;
              bandDropdown.disabled = false; // Enable band when color is selected
              // Remove size-selected class from band parent element
              if (bandDropdown.parentElement) {
                bandDropdown.parentElement.classList.remove('size-selected');
              }
            }
            if (cupDropdown) {
              cupDropdown.selectedIndex = 0;
              cupDropdown.disabled = true; // Keep cup disabled until band is selected
              // Remove size-selected class from cup parent element
              if (cupDropdown.parentElement) {
                cupDropdown.parentElement.classList.remove('size-selected');
              }
            }
            
            self.updateSizeDropdown('band');
            self.updateSizeDropdown('cup');
            self.checkAndEnableAddToBagButton();
          }

        const productUrl = self.state.product.colors[color.value].url;

        fetch(`${productUrl}.js`)
          .then(response => response.json())
          .then(data => {
          const variantsArray = data.variants;
          const newVariants = {};
          variantsArray.forEach(variant => {
            const key = variant.option2;
            newVariants[key] = {
              id: variant.id,
              sku: variant.sku,
              price: variant.price,
              compare_at_price: variant.compare_at_price
            };
          });
          this.state.response.variants = newVariants;
          })
          .catch(error => {
            console.error('Error to get product:', error);
          });
        });
      });
    }

    updateSizeDropdown(name) {
      var sizeSelect, availableSizes;

      if (name === 'alpha') {
        sizeSelect = this.querySelector('.js-sizes .js-size-alpha .js-size-dropdown');
        availableSizes = this.state.response.availableSizes;
      } else if (name === 'band') {
        sizeSelect = this.querySelector('.js-sizes .js-size-band .js-size-dropdown');
        availableSizes = [...new Set(this.state.response.availableSizes.map(size => size.substring(0, 2)))];
      } else if (name === 'cup') {
        sizeSelect = this.querySelector('.js-sizes .js-size-cup .js-size-dropdown');
        availableSizes = [...new Set(this.state.response.availableSizes.map(size => size.substring(2)))];
      }

      if (sizeSelect) {
        Array.from(sizeSelect.options).forEach(option => {
          if (availableSizes.includes(option.getAttribute('data-size'))) {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
      }

      // Remove size-selected class from parent element when resetting
      if (sizeSelect && sizeSelect.parentElement) {
        sizeSelect.parentElement.classList.remove('size-selected');
      }

      this.state.selectedVariantId = null;
      this.state.selectedVariant = null;
      this.checkAndEnableAddToBagButton();
      if (sizeSelect && sizeSelect.options.length > 0) {
        sizeSelect.selectedIndex = 0;
      }
    }

    renderImages(img) {
      if (img) {
        this.querySelector('.js-featured-product-img').classList.add('lazyloading');
        this.querySelector('.js-featured-product-img').dataset.src = img;
        this.querySelector('.js-featured-product-img').dataset.srcset = getSrcset(img, this.props.defaultImgSize);
        this.querySelector('.js-featured-product-img').classList.add('lazyload');
      }
    }

    hasBandCup() {
      return this.props.productType === 'Bra' && !this.state.product.tags.includes('alpha');
    }

    renderSizes(name, subStart, subEnd) {
      const product = this.getProduct();
      const sizeTemplate = this.querySelector('.js-template-size').content.cloneNode(true);
      sizeTemplate.querySelector('.js-size').classList.add(`js-size-${name}`);
      let sizes = Object.keys(this.state.response.variants);
      if (name === 'cup' && this.state.bandSize) {
        sizes = sizes.filter(size => size.substring(0, 2) === this.state.bandSize);
      }
      sizes = sizes.map(size => size.substring(subStart, subEnd));
      // Get unique values
      sizes = [...new Set(sizes)];
      // Sort ascending order for bands and cups
      if (name !== 'alpha') {
        sizes.sort();
        sizes.sort(a => {
          if (a === 'AA') {
            return -1;
          }
          return 0;
        });
      }
      const defaultOptionTemplate = sizeTemplate.querySelector('.js-template-size-option').content.cloneNode(true);
      const defaultOption = defaultOptionTemplate.querySelector('.js-size-option');
      let defaultLabel = name === 'alpha' ? 'Select Size' : `Select ${name.charAt(0).toUpperCase() + name.slice(1)}`;
      defaultLabel = defaultLabel[0].toUpperCase() + defaultLabel.slice(1);
      defaultOption.innerHTML = defaultLabel;
      defaultOption.disabled = true;
      defaultOption.selected = true;
      sizeTemplate.querySelector('.js-size-dropdown').appendChild(defaultOptionTemplate);
      for (let size of sizes) {
        let label = size;
        if (size === 'E') label += ' (DD)';
        if (size === 'E½') label += ' (DD½)';
        if (size === 'E-E½') label += ' (DD-DD½)';
        if (size === 'F') label += ' (DDD)';
        if (size === 'G') label += ' (DDDD)';
        if (size === 'H') label += ' (DDDDD)';
        if (size === 'I') label += ' (DDDDDD)';
        const optionTemplate = sizeTemplate.querySelector('.js-template-size-option').content.cloneNode(true);
        const price = parseFloat(label.slice(1));
        const canadaPrice = price * this.props.cadExchangeRate;
        const moneyPrice = `$${Math.ceil(canadaPrice.toFixed(2))}`;
        optionTemplate.querySelector('.js-size-option').innerHTML = (this.isCanada && product.type?.toLowerCase()?.includes('gift card')) ? moneyPrice : label;
        optionTemplate.querySelector('.js-size-option').dataset.size = size;
        optionTemplate.querySelector('.js-size-option').dataset.name = name;
        // Set active size from state
        let populateSize = false;
        if (name === 'band' && size === this.state.bandSize) {
          populateSize = true;
        } else if (name === 'cup' && size === this.state.cupSize) {
          populateSize = true;
        } else if (name === 'alpha') {
          populateSize = true;
        }
        // if (populateSize) {
        //   optionTemplate.querySelector('.js-size-option').selected = true;
        // }
        // Handle out of stock
        let outOfStock;
        if (name === 'cup' && this.state.bandSize) {
          const availableSizes = this.getSiblingColor().availableSizes.filter(size => size.substring(0, 2) === this.state.bandSize);
          const availableCupSizes = availableSizes.map(size => size.substring(2));
          if (availableCupSizes.indexOf(size) === -1) {
            outOfStock = true;
          }
        }
        if (name === 'alpha') {
          if (this.state.response.availableSizes.indexOf(size) === -1) {
            outOfStock = true;
          }
        }
        if (outOfStock) {
          optionTemplate.querySelector('.js-size-option').classList.add('out-of-stock-option');
        }
        sizeTemplate.querySelector('.js-size-dropdown').appendChild(optionTemplate);
      }
      this.querySelector('.js-sizes').appendChild(sizeTemplate);
      
      // Disable size dropdowns initially if no color is selected
      const sizeDropdown = this.querySelector(`.js-sizes .js-size-${name} .js-size-dropdown`);
      if (sizeDropdown) {
        if (!this.state.selectedColor) {
          // If no color is selected, disable all dropdowns
          sizeDropdown.disabled = true;
        } else if (name === 'cup' && !this.state.bandSize) {
          // If there's a color but no band selected, disable only cup
          sizeDropdown.disabled = true;
        }
      }
    }

    handleSizeSelection() {
      if (this.querySelector('.js-sizes')) {
        this.querySelector('.js-sizes').addEventListener('change', (event) => {
          if (!this.hasBandCup()) {
            const selectedSize = event.target.value;
            const variantId = this.state.response.variants[selectedSize]?.id;
            if (variantId) {
              this.state.selectedVariantId = variantId;
              this.state.selectedVariant = this.state.response.variants[selectedSize];
              this.querySelector('.js-add-to-bag-error').classList.add('hidden');
              this.checkAndEnableAddToBagButton();
            }
            
          } else {
            if (event.target.parentElement.parentElement.classList.contains('js-size-band')) {
              this.state.bandSize = event.target.value;
              // Add size-selected class to band parent element
              event.target.parentElement.classList.add('size-selected');
              this.updateCupOptionsBasedOnBand();
            }
            if (event.target.parentElement.parentElement.classList.contains('js-size-cup')) {
              this.state.cupSize = event.target.value;
              // Add size-selected class to cup parent element
              event.target.parentElement.classList.add('size-selected');
            }

            const selectedSize = this.state.bandSize + this.state.cupSize
            const variantId = this.state.response.variants[selectedSize]?.id;
            if (variantId) {
              this.state.selectedVariantId = variantId;
              this.state.selectedVariant = this.state.response.variants[selectedSize];
              this.querySelector('.js-add-to-bag-error').classList.add('hidden');
              this.checkAndEnableAddToBagButton();
            }
          }
        });
      }
    }

    updateCupOptionsBasedOnBand() {
      const cupDropdown = this.querySelector('.js-sizes .js-size-cup .js-size-dropdown');
      if (!cupDropdown) return;

      if (!this.state.bandSize) {
        // If no band is selected, disable the cup dropdown
        cupDropdown.disabled = true;
        this.state.cupSize = null;
        this.state.selectedVariantId = null;
        this.state.selectedVariant = null;
        this.checkAndEnableAddToBagButton();
        return;
      }

      // Enable the cup dropdown when band is selected
      cupDropdown.disabled = false;

      // Get available cup sizes for the selected band
      const availableSizesForBand = this.state.response.availableSizes.filter(size => 
        size.substring(0, 2) === this.state.bandSize
      );
      const availableCupSizes = [...new Set(availableSizesForBand.map(size => size.substring(2)))];

      // Update cup dropdown options
      Array.from(cupDropdown.options).forEach(option => {
        const cupSize = option.getAttribute('data-size');
        if (cupSize && availableCupSizes.includes(cupSize)) {
          option.disabled = false;
          option.classList.remove('out-of-stock-option');
        } else if (cupSize) {
          option.disabled = true;
          option.classList.add('out-of-stock-option');
        }
      });

      // Reset cup selection if no longer available
      if (this.state.cupSize && !availableCupSizes.includes(this.state.cupSize)) {
        this.state.cupSize = null;
        cupDropdown.selectedIndex = 0;
        // Remove size-selected class from cup parent element when reset
        if (cupDropdown.parentElement) {
          cupDropdown.parentElement.classList.remove('size-selected');
        }
      }

      // Clear variant selection if cup is no longer available
      if (!this.state.cupSize) {
        this.state.selectedVariantId = null;
        this.state.selectedVariant = null;
        this.checkAndEnableAddToBagButton();
      }
    }

    checkAndEnableAddToBagButton() {
      const addToBagBtn = this.querySelector('.js-add-to-bag');
      if (addToBagBtn && this.state.selectedVariantId && this.state.selectedVariant && 
          this.state.selectedVariantId !== null && this.state.selectedVariant !== null &&
          this.state.selectedVariantId !== undefined && this.state.selectedVariant !== undefined) {
        addToBagBtn.removeAttribute('disabled');
      } else if (addToBagBtn) {
        addToBagBtn.setAttribute('disabled', 'disabled');
      }
    }

    handleAddToBag() {
      if (this.querySelector('.js-add-to-bag')) {
        const addToBagBtn = this.querySelector('.js-add-to-bag');
        if (addToBagBtn) {
          addToBagBtn.setAttribute('disabled', 'disabled');
        }
        this.querySelector('.js-add-to-bag').addEventListener('click', async (event) => {
          if (this.state.selectedVariantId) {
            event.preventDefault();

            try {
              this.querySelector('.js-add-to-bag').innerHTML = 'Adding to Bag';
              this.querySelector('.js-add-to-bag').classList.add('add-to-bag-btn--loading');
              const payload = {
                id: this.state.selectedVariantId,
                quantity: 1,
                properties: {
                  _tags: filterProductTags(this.state.response.tags)
                }
              };
              const price = this.state.selectedVariant ? this.state.selectedVariant.price : this.state.response.price;
              const compareAtPrice = this.state.selectedVariant ? this.state.selectedVariant.compare_at_price : this.state.response.compare_at_price;
              if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
                payload.properties._compareAtPriceCa = compareAtPrice;
              } else if (compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = compareAtPrice;
                payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
              }
              
              if (window.cart_settings?.checkoutFinalSaleLabel && payload.properties._tags?.includes('__label: Final Sale')) {
                payload.properties['Final Sale'] = window.cart_settings.checkoutFinalSaleLabel;
              }

              await window.cartManager.addItem(payload);
              window.dispatchEvent(new CustomEvent('update-cart'));

              window.sendGTMData && window.sendGTMData({
                event: 'complete-the-look-item-added',
                page_location: window.location.href || null,
                customer_id: window.theme.customer.id || null,
                product_id: window.cartManager.getLocalCart().items.filter((pd) => pd.id === this.state.selectedVariantId)[0]?.product_id,
                variant_id: this.state.selectedVariantId
              });

              this.querySelector('.js-add-to-bag').classList.remove('add-to-bag-btn--loading');
              this.querySelector('.js-add-to-bag-error').classList.add('hidden');
              this.querySelector('.js-add-to-bag').innerHTML = 'Add to Bag';
            } catch (err) {
              this.querySelector('.js-add-to-bag-error').textContent = 'Sorry, please try again later';
              this.querySelector('.js-add-to-bag-error').classList.remove('hidden');
            }
          } else {
            this.querySelector('.js-add-to-bag-error').textContent = 'Select a size';
            this.querySelector('.js-add-to-bag-error').classList.remove('hidden');
          }
        });
      }
    }
  });
}
